import axios from 'axios'
import Analysis from './analysis'
import History from './history'
import Overview from './overview'
import Metrics from './metrics'
import Setups from './setups'
import Users from './users'
import QualityMonitoring from './monitoring'
import LatestForecast from './latestForecast'
import Turbines from './turbines'
import QM from './qm'
import ConwxPortfolio from './conwxPortfolio'
import PowerCurve from './powerCurve'

// const API_URL = 'https://dev.forecastui.conwx.com'
const API_URL = process.env.REACT_APP_API_URL

const Api = {
  authenticateUser(data) {
    return axios({
      method: 'post',
      url: `${API_URL}/login`,
      data,
    })
  },
  authenticateOidc(idToken) {
    return axios({
      method: 'post',
      url: `${API_URL}/auth/oidc`,
      data: { id_token: idToken },
    })
  },
  Analysis,
  History,
  Overview,
  Metrics,
  Setups,
  Users,
  QualityMonitoring,
  LatestForecast,
  Turbines,
  QM,
  ConwxPortfolio,
  PowerCurve,
}

export default Api
